import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import Paginate from "vuejs-paginate";
import { Validator } from "vee-validate";
import VueAlertify from 'vue-alertify';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: "handoverDashboard",
  components: { Paginate },
  props: [],
  mixins:[PageTracker],
  data() {
    return {
      pageno: 0,
      pagecount: 0,
      fromDate: "",
      toDate: "",
      processmode: "",
      status: "",
      returnArray: [],
      finalArray:[],
      objArray:[],
      agentDetailss: [],
      agentDetails:[],
      agentShipmentDetails: [],
    };
  },
  computed: {},
  async mounted() {
    let validateUser = await this.validateJwtToken();
    this.getIntializeValue();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userid = userdetail.userid
    this.localusermailid = userdetail.username
  },
  methods: {
    searchAgent() {
      let obj = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        processmode: this.processmode,
        status: this.status,
        offset: 0,
        limit: 1000
      };
      axios({
        method: "POST",
        url:  apiUrl.api_url + 'HandoverDashboard/getAllAgents',
        data: obj,
        header: {
          "content-type": "application/json"
        }
      }).then(
        result => {
            if(result.data.code == 200 ){
            this.returnArray = result.data.data;
            let totalRows=this.returnArray.length;
            if (totalRows < 10) {
              this.pagecount = 1;
            } else {
              this.pagecount = Math.ceil(totalRows / 10);
            }
            this.objArray=this.returnArray;
            this.showTable = true;
            this.agentDetailss=[];
            console.log('heyy');
            this.objArray.forEach(obj =>{
              let finalobj={
                batchid:obj.batchid,
                total_shipments:obj.total_shipments,
                inscan:obj.inscan,
                pendinginscan:obj.pendinginscan,
                shortage:obj.shortage,
                overage:obj.overage,
                status:obj.status,
                couriercompanyname:obj.couriercompanyname,
                createddate:obj.createddate
              }
                let payload={
                  id:obj.hubid
                }
                  axios({
                    method: "POST",
                    url: apiUrl.api_url + "external/getHubServiceCenterDetails",
                    data: payload,
                    header: {
                      "content-type": "application/json"
                    }
                  }).then(
                    result => {
                      obj.hubname = result.data.data[0].HubName;
                      finalobj.hubname=result.data.data[0].HubName;
                      this.agentDetailss.push(obj);
                      this.agentDetails.push(finalobj);
                    },
                    error => {
                      console.error("error:", error);
                    }
                  );
            });
          } else {
            //console.log('false');
            this.$alertify.error(result.data.message);
          }
        },
        error => {
          console.error("error:", error);
        }
      );
    },

    getAgentShipmentDetails(id, handovermode, hubid) {
      let obj = {
        batchid: id,
        processmode: handovermode,
        hubid: hubid
      };
      axios({
        method: "POST",
        url:  apiUrl.api_url + 'HandoverDashboard/getAgentShipmentDetails',
        data: obj,
        header: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          this.agentShipmentDetails = result.data.data;
          this.showTable = true;
        },
        error => {
          console.error("error:", error);
        }
      );
    },
    getIntializeValue() {
      this.agentShipmentDetails = [];
      this.returnArray = [];
      this.processmode = "Handover";
      this.status = "All";
      this.fromDate = new Date().toISOString().split("T")[0];
      this.toDate = new Date().toISOString().split("T")[0];
    },
    onDateChange(){
      let fromD=new Date(this.fromDate);
      let toD=new Date(this.toDate);
      if(fromD>toD){
        this.$alertify.alert("Date alert","To date should be greater than from date.");
      }
    },
    exportAgentData(){
      this.getDownloadCsvObject(this.agentDetails);
    },
    getDownloadCsvObject(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "AgentData_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      if(this.returnArray==undefined || this.returnArray.length==0){
      this.$alertify.alert("No data","No data available for download.");
      }
      return result;
   },
    onSubmit: function(event) {
      this.$validator
        .validateAll()
        .then(result => {
          this.searchAgent();
          if (!result) {
            return false;
          }
        })
        .catch(() => {
          console.log("errors exist", this.errors);
        });
    },
    resetForm() {
      this.pageno = 0;
      this.agentShipmentDetails = [];
      this.returnArray = [];
      this.fromDate = "";
      this.toDate = "";
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/handoverDashboard/handoverDashboard.component.js